import type { DeliveryGiantMessageId } from '../../../../../../domain/economy/deliveryGiantMessage';
import {
  deliveryGiantMessageId,
} from '../../../../../../domain/economy/deliveryGiantMessage';
import type { DeliveryUrgency } from '../../../../../../domain/economy/types';
import type { DeliveryPopupTail } from './deliveryPopupLayout';
import badMoodBg from './content/bad_mood.png';
import badMoodUpBg from './content/bad_mood_up.png';
import goodMoodBg from './content/good_mood.png';
import goodMoodUpBg from './content/good_mood_up.png';
import normalMoodBg from './content/normal_mood.png';
import normalMoodUpBg from './content/normal_mood_up.png';
import notNormalMoodBg from './content/not_normal_mood.png';
import notNormalMoodUpBg from './content/not_normal_mood_up.png';
import veryBadMoodBg from './content/very_bad_mood.png';
import veryBadMoodUpBg from './content/very_bad_mood_up.png';

export type DeliveryPopupMoodId =
  | 'good_mood'
  | 'normal_mood'
  | 'not_normal_mood'
  | 'bad_mood'
  | 'very_bad_mood';

export type DeliveryPopupMoodAssets = {
  moodId: DeliveryPopupMoodId;
  backgroundUrl: string;
};

type MoodBackgroundPair = {
  down: string;
  up: string;
};

const MOOD_BACKGROUNDS: Record<DeliveryPopupMoodId, MoodBackgroundPair> = {
  good_mood: {
    down: goodMoodBg,
    up: goodMoodUpBg,
  },
  normal_mood: {
    down: normalMoodBg,
    up: normalMoodUpBg,
  },
  not_normal_mood: {
    down: notNormalMoodBg,
    up: notNormalMoodUpBg,
  },
  bad_mood: {
    down: badMoodBg,
    up: badMoodUpBg,
  },
  very_bad_mood: {
    down: veryBadMoodBg,
    up: veryBadMoodUpBg,
  },
};

const MESSAGE_ID_TO_MOOD: Record<DeliveryGiantMessageId, DeliveryPopupMoodId> = {
  regular: 'good_mood',
  important_day1: 'normal_mood',
  important_day2_plus: 'not_normal_mood',
  urgent_day1: 'bad_mood',
  urgent_day2: 'bad_mood',
  urgent_day3_plus: 'very_bad_mood',
};

export function deliveryPopupMoodId(
  urgency: DeliveryUrgency,
  waitingDay: number,
): DeliveryPopupMoodId {
  const messageId = deliveryGiantMessageId(urgency, waitingDay);
  return MESSAGE_ID_TO_MOOD[messageId];
}

export function getDeliveryPopupMoodAssets(
  urgency: DeliveryUrgency,
  waitingDay: number,
  tail: DeliveryPopupTail = 'down',
): DeliveryPopupMoodAssets {
  return getDeliveryPopupMoodAssetsById(deliveryPopupMoodId(urgency, waitingDay), tail);
}

export function getDeliveryPopupMoodAssetsById(
  moodId: DeliveryPopupMoodId,
  tail: DeliveryPopupTail = 'down',
): DeliveryPopupMoodAssets {
  return {
    moodId,
    backgroundUrl: MOOD_BACKGROUNDS[moodId][tail],
  };
}

export function getDeliveryPopupMoodDownBackground(
  moodId: DeliveryPopupMoodId,
): string {
  return MOOD_BACKGROUNDS[moodId].down;
}

export function getAllDeliveryPopupAssetUrls(): string[] {
  return Object.values(MOOD_BACKGROUNDS).flatMap((pair) => [pair.down, pair.up]);
}
